import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Carousel,
  Form,
  InputGroup,
  Panel,
  Schema,
  Card,
  CardGroup
} from "rsuite";
import EyeIcon from "@rsuite/icons/legacy/Eye";
import EyeSlashIcon from "@rsuite/icons/legacy/EyeSlash";
import { useNavigate } from "react-router-dom";
import { HideLoader, PublicUserToken, ShowLoader, toastError, toastSuccess, UserToken } from "../utils/helper";
import { ChangePasswordAsync, SendOTPRegisterAsync } from "../redux/slice/loginSlice";
import { CryptoJSDecrypt, CryptoJSEncrypt } from "../utils/encryption";
import { useDispatch } from "react-redux";
import { Logout } from "./auth";
import axios from "axios";

const { StringType } = Schema.Types;

const validationSchema = Schema.Model({
  currentPassword: StringType()
    .isRequired('Current password is required'),
  newPassword: StringType()
    .isRequired('New password is required')
    .minLength(8, 'Password must be at least 8 characters')
    .pattern(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .pattern(/[a-z]/, 'Password must contain at least one lowercase letter')
    .pattern(/[0-9]/, 'Password must contain at least one number')
    .pattern(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character'),
  confirmPassword: StringType()
    .isRequired('Confirm password is required')
    .addRule((value, data) => value === data.newPassword, 'Passwords must match'),
});

export default function ChangePassword() {
  const formRef = useRef();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState({});
  const [formValue, setFormValue] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    showCurrentPassword: false,
    showNewPassword: false,
    showConfirmPassword: false
  });

  const [media, setMedia] = useState([]);
  const mobileNumber = JSON?.parse(CryptoJSDecrypt(localStorage?.getItem("LI_PROFILE")))?.MobileNo;
  const dispatch = useDispatch();

  useEffect(() => {
    fetchSlider();
  }, []);

  const fetchSlider = async () => {
    try {
      const UserToken = await axios.post(
        "https://api.imelifeinsurance.com/api/Auth/GenerateUserToken",
        {
          UserToken: "FC62BB2B-7A60-4E55-8FF0-BB549ACD4D85",
        }
      );

      const response = await axios.post(
        "https://api.imelifeinsurance.com/api/MediaServices/GetMediaServiceList",
        {
          mediaType: "CRM_SLIDDER",
        },
        {
          headers: {
            Authorization: "Bearer " + UserToken.data.tokenString,
          },
        }
      );

      setMedia(response.data.mediaServiceList);
    } catch (error) {
      console.error("Error fetching slider:", error);
    }
  };

  const handleSubmit = async () => {
    await UserToken();
    if (!formRef.current.check()) {
      console.error("Form Error", formRef.current);
      return;
    }

    ShowLoader();
    setLoading(true);

    try {
      const payload = {
        flag: "",
        username: "",
        mobileNo: mobileNumber,
        password: formValue.currentPassword,
        newPassword: formValue.newPassword,
      };

      const encryptedPayload = CryptoJSEncrypt(JSON.stringify(payload));

      const response = await dispatch(
        ChangePasswordAsync({
          EncString: encryptedPayload,
        })
      ).unwrap();

      const originalPromiseResult = JSON.parse(CryptoJSDecrypt(response));

      if (originalPromiseResult.Code === "100") {
        await Logout();
        toastSuccess(originalPromiseResult.Message);
      } else {
        toastError(originalPromiseResult.Message);
      }
    } catch (error) {
      console.error("Error changing password: ", error);
      toastError("Failed to change password");
    } finally {
      setLoading(false);
      HideLoader();
    }
  };

  return (
    <React.Fragment>
      <section className="  grid b-1">
        <div className="gap-4 d-flex">
          {/* <div className="">
            <div
              className="shadow rounded-xl p-5 h-full"
              style={{ backgroundColor: "#efeff2" }}
            >
              <div className="container mx-auto relative h-full flex justify-center items-center">
                <Carousel autoplay shape="bar">
                  {media?.map((item, index) => (
                    <div key={index}>
                      <img
                        src={item.image}
                        alt="tli"
                        className="w-full"
                      />
                    </div>
                  ))}
                </Carousel>
                <p className="text-center absolute inset-x-0 bottom-0">
                  <small>
                    IME Life Insurance © Copyright 2024. All rights reserved.
                  </small>
                </p>
              </div>
            </div>
          </div> */}
          <div className="flex justify-center items-center ">
            <div style={{
              "backgroundColor": "white",
              "padding": "10px",
              "borderRadius": "6px"
            }} className=" login-wrapper">
              <img
                src="/images/logo.png"
                alt="business man"
                className="mx-auto"
                width={250}
                height={100}
              />
              <Panel
                header={<h1 className="font-bold text-xl">Change Password</h1>}
                className="w-full my-5"
              >
                <Form
                  fluid
                  ref={formRef}
                  onCheck={setFormError}
                  formValue={formValue}
                  model={validationSchema}
                  onChange={setFormValue}
                  onSubmit={handleSubmit}
                >
                  <Form.Group>
                    <Form.ControlLabel>Current Password</Form.ControlLabel>
                    <InputGroup inside>
                      <Form.Control
                        name="currentPassword"
                        type={formValue.showCurrentPassword ? "text" : "password"}
                        autoComplete="off"
                      />
                      <InputGroup.Button
                        onClick={() => setFormValue({ ...formValue, showCurrentPassword: !formValue.showCurrentPassword })}
                      >
                        {formValue.showCurrentPassword ? <EyeIcon /> : <EyeSlashIcon />}
                      </InputGroup.Button>
                    </InputGroup>
                  </Form.Group>
{/* depections, distinctive   */}
                  <Form.Group>
                    <Form.ControlLabel>New Password</Form.ControlLabel>
                    <InputGroup inside>
                      <Form.Control
                        name="newPassword"
                        type={formValue.showNewPassword ? "text" : "password"}
                        autoComplete="off"
                      />
                      <InputGroup.Button
                        onClick={() => setFormValue({ ...formValue, showNewPassword: !formValue.showNewPassword })}
                      >
                        {formValue.showNewPassword ? <EyeIcon /> : <EyeSlashIcon />}
                      </InputGroup.Button>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group>
                    <Form.ControlLabel>Confirm New Password</Form.ControlLabel>
                    <InputGroup inside>
                      <Form.Control
                        name="confirmPassword"
                        type={formValue.showConfirmPassword ? "text" : "password"}
                        autoComplete="off"
                      />
                      <InputGroup.Button
                        onClick={() => setFormValue({ ...formValue, showConfirmPassword: !formValue.showConfirmPassword })}
                      >
                        {formValue.showConfirmPassword ? <EyeIcon /> : <EyeSlashIcon />}
                      </InputGroup.Button>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group>
                    <ButtonToolbar>
                      <Button
                        type="submit"
                        appearance="primary"
                        className="btn-primary"
                        loading={loading}
                        block
                      >
                        Confirm Change
                      </Button>
                    </ButtonToolbar>
                  </Form.Group>
                </Form>
              </Panel>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}